<script setup>
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-card>
        <v-card
            width="300px"
            outlined
            flat
            v-if="analysis_key.length==0"
        >
            <v-card-text
                class="analysis_mess py-3 px-2"
            >
                <b>キーワードの印象値は以下の要素で変化します。</b>
                <ul style="margin-bottom: 3px">
                    <li>ワードのユニークさ(変更不可)</li>
                    <li>ワード数</li>
                    <li>出現数</li>
                    <li>出現箇所(タイトルやサブタイトル、出現する行数)</li>
                    <li>強調</li>
                </ul>
            </v-card-text>
        </v-card>
        <v-card
            width="300px"
            max-height="calc(100vh - 200px)"
            outlined
            class="mt-2"
            flat
            style="overflow-y: auto;"
            v-else
        >
            <v-card-text outlined>単語をクリックするとプレビューがハイライトされます。</v-card-text>
            <v-list max-height="500">
                <v-list-item
                    v-for="item in analysis_key"
                    v-bind:key="item.key"
                    class="px-0"
                >
                    <v-card
                        width="100%"
                        flat
                        tile
                    >
                        <v-card-text
                            @click="check"
                            :id="'pre-'+item.key"
                        >
                                <v-row>
                                <v-col 
                                    cols="8"
                                    :id="item.key"
                                    class="py-1 px-2"
                                >
                                    <span class="analysis_key" :id="item.key">{{ item.key }}</span>
                                </v-col>
                                <v-col
                                    :id="item.key"
                                    class="py-1 px-2"
                                >
                                    <span class="analysis_key" :id="item.key">{{ item.tfidf }}</span>
                                </v-col>
                                </v-row>
                        </v-card-text>
                    </v-card>
                </v-list-item>
            </v-list>
        </v-card>
</v-card>
</template>
<script>
export default {
    computed :{
        title : function() {
            return this.$store.getters['doc_info/get_title'];
        },
        sub_title : function() {
            return this.$store.getters['doc_info/get_subtitle'];
        },
        summary : function() {
            return this.$store.getters['doc_info/get_summary'];
        },
        e_doc : function() {
            return this.$store.getters['doc_info/get_doc'];
        },
        selected_word :  {
            get : function(){
                return this.$store.getters['preview/get_word'];
            },
            set : function(val){
                this.$store.commit('preview/set_word',val);
            },
        },
        docdata : function(){
            return [this.title,this.sub_title,this.summary,this.e_doc];
        },
    },
    watch : {
        docdata : function(){
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.analysis();
            }, 1000);

        },
    },
    data : function(){
        return {
            analysis_flg : false,
            analysis_key : [],
            message : "",
            message_flg : false,
			timeout   : null,
        };
    },
    methods : {
        analysis : async function(){
            if(this.title == "" || this.title == null)
            {
                this.message = "タイトルが入力されていません。タイトルは必須項目です";
                this.message_flg=true;
                return ;
            }
            let params = {
                'title' : this.title,
                'stitle': this.sub_title,
                'rsummary':this.summary,
                'rdoc':this.e_doc,
            };
            await axios.post("/api/release/word_check",params)
            .then(response => {
                this.analysis_key=response.data;
                //this.analysis_flg=true;
            });
        },
        check    : function(event){
            const elem = document.getElementById('pre-'+event.target.id);
            if(event.target.id.indexOf('pre-') >= 0)
                return;

            if(this.selected_word != "")
            {
                const before_elem = document.getElementById('pre-'+this.selected_word);
                if(before_elem != undefined)
                {
                    before_elem.style.backgroundColor="";
                }
                if(this.selected_word == event.target.id)
                {
                    this.selected_word = "";
                    return ;
                }
            }
            this.selected_word = event.target.id;
            elem.style.backgroundColor="#FDF0F0";
        },
    },
    mounted : function(){
        this.analysis();
    },
}
</script>
